import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle, Label, DropdownItem, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopCurrentFilters from '../components/ShopCurrentFilters.js';
import ShopProductListing from '../components/ShopProductListing.js';


export default class ShopFilterCollapseUnder768 extends Component {
  static propTypes = {
    windowWidth: PropTypes.number.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    toggleProductCategory: PropTypes.func.isRequired,
    jarsCheck: PropTypes.func.isRequired,
    votivesCheck: PropTypes.func.isRequired,
    tartsCheck: PropTypes.func.isRequired,
    checked_jars: PropTypes.bool.isRequired,
    checked_votives: PropTypes.bool.isRequired,
    checked_tarts: PropTypes.bool.isRequired,
    filterOpen: PropTypes.bool.isRequired,
    productCategoryOpen: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const ShopFilterScreen_Under768 = ( 
      <ShopFilterScreen_Under768_CollapseDiv>
        <ShopFilterScreen_Under768_Collapse navbar isOpen={this.props.filterOpen}>
          <Nav className="ml-auto" navbar >
            <NavItem >
              <NavLink onClick={this.props.toggleFilter} >
                  <SpanInDropdown>Filter</SpanInDropdown>
                  <img src={require("../media/tinyX.png")} ></img>
              </NavLink>
            </NavItem>

            {/* ******************************** PRODUCT CATEGORY DROPDOWN ******************************** */}
            <Dropdown nav isOpen={this.props.productCategoryOpen} toggle={this.props.toggleProductCategory } >
              <DropdownToggle_s nav caret productCategoryOpen={this.props.productCategoryOpen} >
                  <SpanHeader>Product Category</SpanHeader>
              </DropdownToggle_s>
              <DropdownMenu>
                
                <DropdownItem onChange={this.props.jarsCheck} toggle={false} >
                  <Container >
                      <Label check >
                         <Input type="checkbox"
                          checked={this.props.checked_jars} 
                           /> {' '}
                         <p>Jar Candles</p>
                       </Label>
                  </Container>
                </DropdownItem>
                
                <DropdownItem onChange={ this.props.votivesCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_votives} 
                           /> {' '}
                         <p>Votives</p>
                       </Label>
                  </Container>
                </DropdownItem>
                <DropdownItem onChange={ this.props.tartsCheck } toggle={false}>
                  <Container>
                      <Label check>
                         <Input type="checkbox" 
                          checked={this.props.checked_tarts} 
                           /> {' '}
                         <p>Tarts</p>
                       </Label>
                  </Container>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>

          <DoneBtnContainer>
            <Button onClick={this.props.toggleFilter}>Done</Button>
          </DoneBtnContainer>

        </ShopFilterScreen_Under768_Collapse> 
      </ShopFilterScreen_Under768_CollapseDiv>
    );

    return (
      <FluidContainer className="p-0" fluid>
          {ShopFilterScreen_Under768}
      </FluidContainer>
    );
  }
}

const FluidContainer = styled(Container)` z-index: 6; `;

const Container_Under768 = styled(Container)`  `;


const ShopFilterScreen_Under768_CollapseDiv = styled.div`
  .dropdown-menu {
    position: relative!important;
    transform: none!important;
    padding-top: 0;
    
    button.dropdown-item {
      padding: 0;

      :active, :focus {
        background: #D0C1A0;
        outline: none;
      }
    }

    .container {
      height: 60px;
      line-height: 60px;
      padding-left: 31px;

      label {
        height: 100%;

        input {
          width: 20px;
          height: 20px;
          margin-top: 14px;
        }

        p {
          margin: -6px 0 0 6px;
          font-size: 18px!important;
        }
      }

      :focus {
        outline: none;
      }
    }
  }

  .collapsing {
    height: 0!important;
    width: 0!important;
    transition: height .5s ease, width .5s ease!important;
  }
  .show {
    height: 100%!important;
    width: 100%!important;
    transition: height .5s ease, width .5s ease!important;
  }
`;


const ShopFilterScreen_Under768_Collapse = styled(Collapse)`
  position: fixed!important;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  height: 100%!important;
  width: 100%!important;
  background-color: #D0C1A0;
  color: white;
  z-index: 2;

  .nav-item {
    height: 60px;
    width: 100%;
    line-height: 60px;
    border-bottom: 1px solid #BCA368;
    display: table; 

    div.dropdown-menu {
      background: #D0C1A0;
      margin: 0;
      border: none;

      button.dropdown-item {
        div { background: #D0C1A0!important; }
      }
    }

    :hover {
        spanheader {
          border-bottom: none;
        } 
    }

    button {
      :hover {
        background: #D0C1A0;
      }
    }

    a.nav-link {
      margin-left: 16px;
      padding: 0;
      cursor: pointer;

      img {
        display: inline-block;
        float: right;
        width: 20px;
        height: 20px;
        margin: 20px 10px 0 0!important;
        cursor: pointer;
      }

      a {
        color: black;
      }
    }
  }
`;


const SpanInDropdown = styled.span`
  color: black;
  font-family: 'Raleway';
  font-size: 14px;
`;
const SpanHeader = styled.span`
  color: black;
  font-size: 16px;
  font-family: 'Raleway';
`;


const DropdownToggle_s = styled(({ productCategoryOpen, ...rest }) => <DropdownToggle {...rest} />)`
    ::after {
      color: black;
        float: right;
        margin: 30px 10px 0 0;
        border-top-width: ${a => a.productCategoryOpen ? "0!important" : "4.3px!important;"};
        border-bottom: ${a => a.productCategoryOpen ? "4.3px solid black!important" : ""};
    }
`;


const DoneBtnContainer = styled(Container)`
    position: absolute!important;
    bottom: 20px!important;
    width: 100%!important;
    height: 60px;
    border-top: 1px solid #8A572A;
    padding: 0!important;
    background: #D0C1A0;

    button {
      width: 90%!important;
      position: absolute;
      bottom: -8px;
      margin: 0 5% 0 5%!important;
      background: #8B572A;
      color: white;
      cursor: pointer;
      border: none;
      font-size: 16px;
      font-family: 'Raleway';
      font-weight: bold;

      :hover {
        background: #8B572A;
        color: white;
      }
    }
`;


/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopFilterCollapseUnder768.js